import { CountedFilter } from 'component/filter';
import { component, demoFile, story, CLICK } from 'system/demo';
import { useState } from 'react';
import { HorizBox } from 'component/basics';
import { View } from 'react-native';

demoFile('component/filter');

function CountedFilterDemo() {
    const [selection, setSelection] = useState(null);
    return <View>
        <CountedFilter label='!Cats' value='cat' selection={selection} count={12} maxCount={20} onChangeSelection={setSelection} />
    </View>
}

component('CountedFilter', CountedFilterDemo, {}, [
    story('Toggle', [CLICK('!Cats')])
]);
